import { useCallback } from 'react'

import type { QuoteStopType } from '@fv/client-types'

import type { FormSectionProps } from '@/components/inputs/types'

import { ShipmentLocationForm } from '../shipment-location-form/ShipmentLocationForm'
import type { ShipmentLocationFormModel } from '../shipment-location-form/types'
import { useBookingFormCtx } from './BookingFormProvider'
import { useCarrierBookingFormSettings } from './bookFuncs'

type LocationFormProps = FormSectionProps & {
  type: QuoteStopType
}

export const BookingFormLocation = ({ disabled, type }: LocationFormProps) => {
  const { setLocationValues } = useBookingFormCtx(s => s.actions)

  const location = useBookingFormCtx(s =>
    s.locations.find(x => x.type === type),
  )
  const requireEmail =
    useCarrierBookingFormSettings()?.requiresOriginEmail && type === 'origin'
  const workflow = useBookingFormCtx(s => s.workflow)

  const onChange = useCallback(
    (val: ShipmentLocationFormModel) => setLocationValues(type, val),
    [setLocationValues, type],
  )

  if (!location) return null

  return (
    <ShipmentLocationForm
      disabled={disabled}
      workflow={workflow}
      value={location}
      onChange={onChange}
      allowDateEdit={false}
      requireEmail={requireEmail}
    />
  )
}
